import { Component } from '@angular/core';

@Component({
  selector: 'allas-beneficios-del-programa',
  imports: [],
  template: `
    <section class="grid grid-cols-12 mx-auto w-full max-w-6xl xl:mt-12">
      <div
        class="col-span-12 xl:col-span-4 flex flex-col items-center mt-6 xl:mt-0"
      >
        <img
          src="/images/services/afiliaciones/mano-puntos.webp"
          alt="Bienvenida al Programa"
          class="h-20 w-auto object-cover"
        />
        <span class="font-extrabold fs-condensed text-xl mt-2">
          Bienvenida al Programa:
        </span>
        <p class="text-center text-sm">
          1,000 puntos Gratis de Bienvenida <br />
          Descuentos Especiales: Hasta 15% de <br />
          descuento en productos seleccionados
        </p>
      </div>
      <div
        class="col-span-12 xl:col-span-4 flex flex-col items-center mt-6 xl:mt-0"
      >
        <img
          src="/images/services/afiliaciones/caja-puntos.webp"
          alt="Acumulación de Puntos"
          class="h-20 w-auto object-cover"
        />
        <span class="font-extrabold fs-condensed text-xl mt-2">
          Acumulación de Puntos:
        </span>
        <p class="text-center text-sm">
          Gana puntos por cada compra y <br />
          canjéalos por premios
        </p>
      </div>
      <div
        class="col-span-12 xl:col-span-4 flex flex-col items-center mt-6 xl:mt-0"
      >
        <img
          src="/images/services/afiliaciones/click-telefono.webp"
          alt="Aplicación Móvil"
          class="h-20 w-auto object-cover"
        />
        <span class="font-extrabold fs-condensed text-xl mt-2">
          App Movil:
        </span>
        <p class="text-center text-sm">
          Gestiona tus recompensas y <br />
          beneficios desde tu celular
        </p>
      </div>
    </section>
  `,
})
export class BeneficiosDelPrograma {}
